<style lang="less">
.pd-timeout {
  display: flex;
  align-items: stretch;
  width: 100%;
  height: 100%;
  .ivu-input-wrapper {
    height: 100% !important;
    flex: 1;
    min-width: 0;
  }
  .ivu-input {
    background: none;
    border: none;
    height: 100% !important;
    border-radius: 0;
    font-size: 12px;
  }
  .pd-timeout-unit {
    flex-shrink: 0;
    width: 64px;
    .ivu-select {
      height: 100%;
    }
    .ivu-select-selection {
      background: #33333322;
      border: none;
      border-radius: 0;
      height: 100% !important;
      box-shadow: none;
    }
    .ivu-select-selected-value,
    .ivu-select-placeholder {
      font-size: 12px !important;
      line-height: 24px !important;
      padding-left: 6px !important;
      padding-right: 18px !important;
    }
  }
}
.pd-timeout-disabled {
  background: var(--border) !important;
}
</style>

<template>
  <div
    class="pd-embed-control pd-timeout"
    :class="{ 'pd-timeout-disabled': !editable || disabled }"
  >
    <template v-if="editable">
      <Input
        :value="amount"
        number
        :placeholder="option && option.placeholder ? option.placeholder : '留空不限时'"
        @input="onAmountInput"
      />
      <Select
        class="pd-timeout-unit"
        size="small"
        transfer
        :value="unit"
        :disabled="!editable"
        @on-change="onUnitChange"
      >
        <Option v-for="u in units" :key="u" :value="u">{{ u }}</Option>
      </Select>
    </template>
    <template v-else>
      <div class="flex-wrap pd-embed-value">
        <template v-if="seconds > 0">{{ amount }}{{ unit }}</template>
        <template v-else>不限时</template>
      </div>
    </template>
  </div>
</template>

<script>
const UNIT_SECONDS = {
  '分钟': 60,
  '小时': 3600,
  '天': 86400,
};

function toSeconds(amount, unit) {
  const n = Number(amount);
  if (amount === '' || amount == null || Number.isNaN(n) || n <= 0) {
    return undefined;
  }
  const factor = UNIT_SECONDS[unit] || UNIT_SECONDS['小时'];
  return Math.round(n * factor);
}

function toAmount(seconds, unit) {
  const s = Number(seconds);
  if (!s || Number.isNaN(s) || s <= 0) return '';
  const factor = UNIT_SECONDS[unit] || UNIT_SECONDS['小时'];
  const v = s / factor;
  // 尽量去掉多余小数
  return Number.isInteger(v) ? v : Math.round(v * 1000) / 1000;
}

function preferUnit(seconds, fallback = '小时') {
  const s = Number(seconds);
  if (!s || Number.isNaN(s) || s <= 0) return fallback;
  if (s % 86400 === 0) return '天';
  if (s % 3600 === 0) return '小时';
  if (s % 60 === 0) return '分钟';
  return fallback;
}

export default {
  props: ['value', 'editable', 'option', 'disabled', 'db'],
  data() {
    const defaultUnit = (this.option && this.option.defaultUnit) || '小时';
    const unit = (this.db && this.db.timeoutUnit) || preferUnit(this.value, defaultUnit);
    return {
      units: ['分钟', '小时', '天'],
      unit,
      amount: toAmount(this.value, unit),
    };
  },
  computed: {
    seconds() {
      const s = Number(this.value);
      return s > 0 ? s : 0;
    },
  },
  watch: {
    value: {
      handler(v) {
        // 外部值变化时按当前单位（或可整除单位）刷新展示，绝不改写秒值
        const defaultUnit = (this.option && this.option.defaultUnit) || '小时';
        const unit = (this.db && this.db.timeoutUnit) || preferUnit(v, defaultUnit) || this.unit;
        this.unit = unit;
        this.amount = toAmount(v, unit);
      },
    },
  },
  mounted() {
    const defaultUnit = (this.option && this.option.defaultUnit) || '小时';
    if (!this.unit) {
      this.unit = defaultUnit;
    }
    this.syncUnitToDb(this.unit);
  },
  methods: {
    syncUnitToDb(unit) {
      if (this.db && typeof this.db === 'object') {
        this.$set(this.db, 'timeoutUnit', unit);
      }
    },
    onAmountInput(v) {
      this.amount = v;
      this.syncUnitToDb(this.unit);
      const sec = toSeconds(v, this.unit);
      this.$emit('input', sec);
    },
    onUnitChange(unit) {
      // 先用旧单位把当前展示值换成秒，再换单位展示（秒不变）
      const prevSec = this.seconds > 0 ?
        this.seconds :
        toSeconds(this.amount, this.unit);
      this.unit = unit;
      this.syncUnitToDb(unit);
      if (prevSec) {
        this.amount = toAmount(prevSec, unit);
        this.$emit('input', prevSec);
      } else {
        this.amount = '';
        this.$emit('input', undefined);
      }
    },
  },
};
</script>
